import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { ValidationNotificationModel } from './model/validation-notification.model';
import {UntypedFormControl} from '@angular/forms';

@Component({
    selector: 'app-validation-notification',
    templateUrl: './validation-notification.component.html',
    styleUrls: ['./validation-notification.component.scss'],
    providers: [ValidationNotificationModel],
    standalone: true
})
export class ValidationNotificationComponent implements OnInit, OnChanges {
  @Input() control: UntypedFormControl;
  @Input() isSubmitted: boolean = true;

  constructor(public model: ValidationNotificationModel) { }

  ngOnInit() {
    this.model.setControl(this.control);
    this.model.setIsSubmitted(this.isSubmitted);
  }

  ngOnChanges() {
    this.model.setControl(this.control);
    this.model.setIsSubmitted(this.isSubmitted);
  }

}
